var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FE0300;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.5,324.2l46.9,79.3h1.8l47.2-79.3H295l-71,116.4L296.6,557H240l-47.7-79.4h-1.8L142.8,557H86.4l72.8-116.4 L87.8,324.2H143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M517.7,440.6c0,25.4-4.8,47-14.4,64.8c-9.6,17.8-22.6,31.4-39.1,40.7c-16.5,9.4-35,14-55.5,14 c-20.7,0-39.2-4.7-55.7-14.1c-16.4-9.4-29.4-23-39-40.8c-9.5-17.8-14.3-39.4-14.3-64.7c0-25.4,4.8-47,14.3-64.8 c9.5-17.8,22.5-31.4,39-40.7c16.4-9.4,35-14,55.7-14c20.5,0,39,4.7,55.5,14c16.5,9.4,29.5,22.9,39.1,40.7 C512.9,393.6,517.7,415.2,517.7,440.6z M467.8,440.6c0-16.4-2.4-30.3-7.3-41.6c-4.9-11.3-11.8-19.8-20.6-25.7 c-8.9-5.8-19.2-8.8-31.1-8.8c-11.9,0-22.3,2.9-31.1,8.8c-8.9,5.8-15.7,14.4-20.6,25.7c-4.9,11.3-7.3,25.2-7.3,41.6 s2.4,30.3,7.3,41.6c4.9,11.3,11.8,19.8,20.6,25.7c8.9,5.8,19.2,8.7,31.1,8.7c11.9,0,22.3-2.9,31.1-8.7c8.9-5.8,15.7-14.4,20.6-25.7 C465.4,470.9,467.8,457,467.8,440.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M542.6,324.2h60.7l64.1,156.4h2.7l64.1-156.4h60.7V557h-47.7V405.5h-1.9l-60.2,150.3h-32.5l-60.2-150.9h-1.9 v152h-47.7V324.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXomIcon);
export default __webpack_public_path__ + "static/media/xom_icon.43b0d382ef9e4aa5d4c93b6a9daf30da.svg";
export { ForwardRef as ReactComponent };